module.exports = __webpack_public_path__ + "images/e924c5fc96ea1b2ddfe746ef95d74778.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/gift-categories/top-under25.jpg
// module id = 1094
// module chunks = 0